import { Component } from '@angular/core';

@Component({
  selector: 'xp-health-center',
  templateUrl: './health-center.component.html',
  styleUrl: './health-center.component.scss'
})
export class HealthCenterComponent {

}
